import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '../../../assets/logo.png'


const _hoisted_1 = { class: "p-4 mx-auto max-w-[900px] select-none" }
const _hoisted_2 = { class: "mx-auto w-max text-center" }
const _hoisted_3 = { class: "mt-2 text-center" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center text-center mt-4 cursor-pointer space-x-5"
}
const _hoisted_5 = {
  key: 0,
  class: "space-y-3 mt-4"
}
const _hoisted_6 = { class: "flex items-center space-x-4 mt-1" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = {
  key: 1,
  class: "mt-4 space-y-3"
}
const _hoisted_10 = {
  key: 2,
  class: "mt-8"
}
const _hoisted_11 = { class: "mt-8" }
const _hoisted_12 = { class: "space-y-2 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusModal = _resolveComponent("StatusModal")!
  const _component_InputComponent = _resolveComponent("InputComponent")!
  const _component_FileInputComponent = _resolveComponent("FileInputComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("img", {
        src: _imports_0,
        alt: "logo",
        class: "rounded-md w-24 h-24 mx-auto"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.appName), 1)
    ]),
    _createVNode(_component_StatusModal, { state: _ctx.successDialog }, null, 8, ["state"]),
    (_ctx.typeForm === 'form' || _ctx.typeForm === 'easy')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["px-2 py-2 rounded-md w-full border border-primary", { 'bg-primary': _ctx.typeForm == 'easy' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.typeForm = 'easy'))
          }, " Свяжитесь со мной ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["px-2 py-2 rounded-md w-full border border-primary", { 'bg-primary': _ctx.typeForm == 'form' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.typeForm = 'form'))
          }, " Создайте профиль ", 2)
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", null, [
      (_ctx.typeForm == 'form')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _cache[17] || (_cache[17] = _createElementVNode("div", null, "Тип работы", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.workType) = $event)),
                    type: "radio",
                    value: "driver",
                    name: "default-radio",
                    class: "w-5 h-5 text-blue-600 bg-gray-100 border-gray-300"
                  }, null, 512), [
                    [_vModelRadio, _ctx.workType]
                  ]),
                  _cache[15] || (_cache[15] = _createElementVNode("label", {
                    for: "default-radio-2",
                    class: "ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  }, "Водитель", -1))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.workType) = $event)),
                    type: "radio",
                    value: "courier",
                    name: "default-radio",
                    class: "w-5 h-5 text-blue-600 bg-gray-100 border-gray-300"
                  }, null, 512), [
                    [_vModelRadio, _ctx.workType]
                  ]),
                  _cache[16] || (_cache[16] = _createElementVNode("label", {
                    for: "default-radio-2",
                    class: "ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  }, "Курьер", -1))
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[18] || (_cache[18] = _createElementVNode("div", null, [
                _createTextVNode("ФИО "),
                _createElementVNode("span", { class: "text-red font-medium" }, "*")
              ], -1)),
              _createVNode(_component_InputComponent, {
                modelValue: _ctx.fullName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fullName) = $event)),
                model: _ctx.fullName,
                placeholder: "Сидоров Иван Петрович"
              }, null, 8, ["modelValue", "model"])
            ]),
            _createElementVNode("div", null, [
              _cache[19] || (_cache[19] = _createElementVNode("div", null, [
                _createTextVNode("Номер телефона "),
                _createElementVNode("span", { class: "text-red font-medium" }, "*")
              ], -1)),
              _createVNode(_component_InputComponent, {
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.phone) = $event)),
                type: "tel",
                model: _ctx.phone,
                placeholder: "(928) 738 25-62",
                mask: "(###) ### ##-##",
                prefix: "+7",
                maxlength: "15"
              }, null, 8, ["modelValue", "model"])
            ]),
            _createElementVNode("div", null, [
              _cache[20] || (_cache[20] = _createElementVNode("div", null, [
                _createTextVNode("Фото паспорта "),
                _createElementVNode("span", { class: "text-red font-medium" }, "*")
              ], -1)),
              _createVNode(_component_FileInputComponent, {
                onFileUpload: _cache[6] || (_cache[6] = (val) => (_ctx.filePassport = val))
              })
            ]),
            _createElementVNode("div", null, [
              _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                _createTextVNode(" Фото с паспортом в руках "),
                _createElementVNode("span", { class: "text-red font-medium" }, "*")
              ], -1)),
              _createVNode(_component_FileInputComponent, {
                onFileUpload: _cache[7] || (_cache[7] = (val) => (_ctx.fileSelfiePassport = val))
              })
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _cache[22] || (_cache[22] = _createElementVNode("div", null, [
                _createTextVNode(" Водительское удостоверение "),
                _createElementVNode("span", { class: "text-red font-medium" }, "*")
              ], -1)),
              _createVNode(_component_FileInputComponent, {
                onFileUpload: _cache[8] || (_cache[8] = (val) => (_ctx.fileDriverLicense = val))
              })
            ], 512), [
              [_vShow, _ctx.workType == 'driver']
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _cache[23] || (_cache[23] = _createElementVNode("div", null, [
                _createTextVNode("Фото СТС "),
                _createElementVNode("span", { class: "text-red font-medium" }, "*")
              ], -1)),
              _createVNode(_component_FileInputComponent, {
                onFileUpload: _cache[9] || (_cache[9] = (val) => (_ctx.fileSTS = val))
              })
            ], 512), [
              [_vShow, _ctx.workType == 'driver']
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _cache[24] || (_cache[24] = _createElementVNode("div", null, [
                _createTextVNode(" Лицензия такси "),
                _createElementVNode("span", { class: "text-gray-400" }, "(если есть)")
              ], -1)),
              _createVNode(_component_FileInputComponent, {
                onFileUpload: _cache[10] || (_cache[10] = (val) => (_ctx.fileTaxiLicense = val))
              })
            ], 512), [
              [_vShow, _ctx.workType == 'driver']
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-red" }, [
              _createElementVNode("span", { class: "font-medium" }, "*"),
              _createTextVNode(" - поле обязательное для заполнения ")
            ], -1)),
            _withDirectives(_createVNode(_component_ButtonComponent, {
              disabled: 
            _ctx.fullName.length < 1 ||
            _ctx.phone.length < 15 ||
            !_ctx.filePassport ||
            !_ctx.fileSelfiePassport ||
            !_ctx.fileDriverLicense ||
            !_ctx.fileSTS
          ,
              loading: _ctx.hasRequest,
              title: "Создать профиль",
              onClickAction: _ctx.sendFullForm
            }, null, 8, ["disabled", "loading", "onClickAction"]), [
              [_vShow, _ctx.workType == 'driver']
            ]),
            _withDirectives(_createVNode(_component_ButtonComponent, {
              disabled: 
            _ctx.fullName.length < 1 ||
            _ctx.phone.length < 15 ||
            !_ctx.filePassport ||
            !_ctx.fileSelfiePassport
          ,
              loading: _ctx.hasRequest,
              title: "Создать профиль",
              onClickAction: _ctx.sendFullForm
            }, null, 8, ["disabled", "loading", "onClickAction"]), [
              [_vShow, _ctx.workType == 'courier']
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.typeForm == 'easy')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _cache[26] || (_cache[26] = _createElementVNode("div", null, [
                _createTextVNode("ФИО "),
                _createElementVNode("span", { class: "text-red font-medium" }, "*")
              ], -1)),
              _createVNode(_component_InputComponent, {
                modelValue: _ctx.fullName,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.fullName) = $event)),
                model: _ctx.fullName,
                placeholder: "Сидоров Иван Петрович"
              }, null, 8, ["modelValue", "model"])
            ]),
            _createElementVNode("div", null, [
              _cache[27] || (_cache[27] = _createElementVNode("div", null, [
                _createTextVNode("Номер телефона "),
                _createElementVNode("span", { class: "text-red font-medium" }, "*")
              ], -1)),
              _createVNode(_component_InputComponent, {
                type: "tel",
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.phone) = $event)),
                maxlength: "15",
                model: _ctx.phone,
                placeholder: "(928) 738 25-62",
                mask: "(###) ### ##-##",
                prefix: "+7"
              }, null, 8, ["modelValue", "model"])
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-red" }, "* - поле обязательное для заполнения", -1)),
            _createVNode(_component_ButtonComponent, {
              disabled: _ctx.fullName.length < 1 || _ctx.phone.length < 15,
              loading: _ctx.hasRequest,
              title: "Свяжитесь со мной",
              onClickAction: _ctx.sendEasyForm
            }, null, 8, ["disabled", "loading", "onClickAction"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.typeForm == 'feedback')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text-base" }, " Ваша заявка успешно отправлена, с вами свяжутся в ближайшее время, спасибо! ", -1)),
            _createElementVNode("div", _hoisted_11, [
              _cache[29] || (_cache[29] = _createTextVNode(" Если вас кто-то пригласил, пожалуйста, впишите его номер телефона ниже ", -1)),
              _createVNode(_component_InputComponent, {
                type: "tel",
                class: "mt-2",
                modelValue: _ctx.feedbackPhone,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.feedbackPhone) = $event)),
                maxlength: "15",
                model: _ctx.feedbackPhone,
                placeholder: "(928) 674 54-72",
                mask: "(###) ### ##-##",
                prefix: "+7"
              }, null, 8, ["modelValue", "model"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_ButtonComponent, {
                title: "Отправить",
                disabled: _ctx.feedbackPhone.length < 15,
                loading: _ctx.hasRequest,
                onClickAction: _ctx.sendFeedback
              }, null, 8, ["disabled", "loading", "onClickAction"]),
              _createVNode(_component_ButtonComponent, {
                title: "Закрыть",
                color: "greyLight",
                onClickAction: _ctx.sendToStore
              }, null, 8, ["onClickAction"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_auto_animate]
    ])
  ]))
}